module.exports = __webpack_public_path__ + "static/media/bullhorn.868ef50b.svg";